import React, { useState } from "react";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import "../HomeScreen.css";
import "./Contact.css";
import Navbar from "../Navbar";
import Footer from "../Footer";

const Contact = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  // null | "sending" | "success" | "error"
  const [status, setStatus] = useState(null);

  const handleChange = (e) =>
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      // Data ko 'enquiry' collection mein save kiya ja raha hai
      await addDoc(collection(db, "enquiry"), {
        ...form,
        enquiryType: "contact us", // Taaki pata chale ki yeh contact form se aaya hai
        createdAt: serverTimestamp(),
      });

      setStatus("success");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      console.error("Error submitting form: ", err);
      setStatus("error");
    }
  };

  const phones = ["9096785868", "9175785868", "9146785868", "9168785868"];

  return (
    <div className="home-container">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section with New Background & Text */}
      <section className="hero-section contact-hero">
        <div className="hero-overlay">
          <h1>
            Let's Plan Your <span style={{
              background: "linear-gradient(135deg, #ff8c00, #ff5500)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent"
            }}> Dream Journey</span>
          </h1>
          <p>
            Have questions about destinations, visas, or custom tours?
            Our travel experts are just a message away, ready to craft your perfect getaway.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="contact-section">
        <div className="contact-grid">

          {/* LEFT — Info Panel */}
          <div className="contact-info-panel">

            {/* Company Logo at the Top Left (Replaced generic icon) */}
            <div className="contact-brand">
              <div className="contact-brand-logo">
                <img src="/assets/images/roamlogo.png" alt="Roam The World Logo" />
              </div>
              <div>
                <h2 className="contact-brand-name">Roam The World</h2>
                <p className="contact-brand-tagline">Making Every Journey Memorable</p>
              </div>
            </div>

            <div className="contact-info-cards">
              {/* Phone */}
              <div className="contact-info-card">
                <div className="contact-info-icon phone-icon">📞</div>
                <div>
                  <p className="contact-info-label">Call Us</p>
                  {phones.map((p) => (
                    <a key={p} href={`tel:+91${p}`} className="contact-info-value">
                      +91 {p}
                    </a>
                  ))}
                </div>
              </div>

              {/* Email (Updated Icon) */}
              <div className="contact-info-card">
                <div className="contact-info-icon email-icon">📧</div>
                <div>
                  <p className="contact-info-label">Email Us</p>
                  <a
                    href="mailto:roamtheworld.ngp@gmail.com"
                    className="contact-info-value"
                  >
                    roamtheworld.ngp@gmail.com
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="contact-info-card">
                <div className="contact-info-icon addr-icon">🏢</div>
                <div>
                  <p className="contact-info-label">Visit Us</p>
                  <p className="contact-info-value addr-text">
                    Shop No 04A, NKY Tower Building, <br />
                    First Floor, Near Ajni Metro Station, <br />
                    Above Federal Bank – 440015
                  </p>
                </div>
              </div>

              {/* Instagram (Updated with Image Icon) */}
              <div className="contact-info-card">
                <div className="contact-info-icon insta-icon">
                  <img
                    src="/assets/images/instalogo.avif"
                    alt="Instagram"
                    style={{ width: '28px', height: '28px', objectFit: 'contain' }}
                  />
                </div>
                <div>
                  <p className="contact-info-label">Follow Us</p>
                  <a
                    href="https://www.instagram.com/roamtheworldofficial"
                    target="_blank"
                    rel="noreferrer"
                    className="contact-info-value insta-link"
                  >
                    @roamtheworldofficial
                  </a>
                </div>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <div className="contact-whatsapp-block">
              <p className="contact-whatsapp-label">Need instant help?</p>
              <button
                className="contact-whatsapp-btn"
                onClick={() =>
                  window.open(
                    "https://wa.me/919096785868?text=Hi! I'd like to know more about your travel packages.",
                    "_blank"
                  )
                }
              >
                <i className="fab fa-whatsapp"></i>
                Chat on WhatsApp
              </button>
            </div>
          </div>

          {/* RIGHT — Contact Form */}
          <div className="contact-form-panel">
            <h3 className="contact-form-title">Send Us a Message</h3>
            <p className="contact-form-subtitle">
              Fill out the form and our team will get back to you within 24 hours.
            </p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="contact-form-row">
                <div className="contact-field">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="John Doe"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="contact-field">
                  <label>Phone Number</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 98765 43210"
                    value={form.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="contact-field">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="contact-field">
                <label>Subject</label>
                <input
                  type="text"
                  name="subject"
                  placeholder="Tour enquiry, Visa help, etc."
                  value={form.subject}
                  onChange={handleChange}
                />
              </div>

              <div className="contact-field">
                <label>Message *</label>
                <textarea
                  name="message"
                  placeholder="Tell us about your travel plans, dates, number of travellers..."
                  rows="5"
                  value={form.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              {/* Status Messages */}
              {status === "success" && (
                <div className="contact-status success">
                  ✅ Message sent! We'll get back to you shortly.
                </div>
              )}
              {status === "error" && (
                <div className="contact-status error">
                  ⚠️ Something went wrong. Please try WhatsApp instead.
                </div>
              )}

              <button
                type="submit"
                className="contact-submit-btn"
                disabled={status === "sending"}
              >
                {status === "sending" ? (
                  <span className="contact-spinner"></span>
                ) : (
                  <>  ╰┈➤Send Message</>
                )}
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Contact;